



















import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
  },
})

export default class Download extends Vue {
  goOtherPage(url: string){
    window.open(url,'_blank')
  }
}

